import * as Mutations from './mutations';
import { TeachersService } from '@/common/services/settings/teachers.service';
import { PaginationParams } from '@/common/utils/pagination-params';
import { clearAllSelected } from '@/store/modules/page/reset';

export const TeachersModule = {
    state: {
        teachers: null,
        teacherId: null,
        teacher: null,
        allTeachers: []
    },
    mutations: {
        [Mutations.SET_TEACHERS](state, teachers) {
            state.teachers = teachers;
        },

        [Mutations.SET_TEACHER_ID](state, teacherId) {
            state.teacherId = teacherId;
        },

        [Mutations.REMOVE_TEACHER_ID](state) {
            state.teacherId = null;
        },

        [Mutations.SET_TEACHER](state, teacher) {
            state.teacher = teacher;
        },

        [Mutations.REMOVE_TEACHER](state) {
            state.teacher = null;
        },

        [Mutations.SET_ALL_TEACHERS](state, allTeachers) {
            state.allTeachers = allTeachers;
        }
    },
    actions: {
        async getTeachers(context) {
            const { data: { content, pageable, totalPages, totalElements, numberOfElements } } =
                await TeachersService.getTeachers(context.getters.schoolId,
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
            context.commit(Mutations.SET_TEACHERS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getTeachers');
                }
            });
            context.dispatch('resetSelectedItems');
        },

        async getAllTeachers(context) {
            const { data } = await TeachersService.getAllTeachers(context.getters.schoolId);
            context.commit(Mutations.SET_ALL_TEACHERS, data);
        },

        async getTeacher(context) {
            const { data } = await TeachersService.getTeacher(context.getters.schoolId, context.getters.teacherId);
            context.commit(Mutations.SET_TEACHER, data);
        },

        async addTeacher(context, form) {
            try {
                context.dispatch('showSpinner');
                await TeachersService.addTeacher(context.getters.schoolId, form);
                await context.dispatch('getTeachers');
            } catch (e) {
                throw e;
            } finally {
                setTimeout(() => {
                    context.dispatch('hideSpinner');
                });
            }
        },

        async bulkUploadTeachers(context, file) {
            await TeachersService.addTeachersBulk(context.getters.schoolId, file);
            await context.dispatch('getTeachers');
        },

        async editTeacher(context, form) {
            try {
                context.dispatch('showSpinner');
                await TeachersService.editTeacher(context.getters.schoolId, context.getters.teacherId, form);
                await context.dispatch('getTeachers');
                context.dispatch('unstageTeacher');
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async deleteTeacher(context, teacherId) {
            await context.dispatch('deleteTeachers', [teacherId]);
        },

        async deleteMultipleTeachers(context) {
            await context.dispatch('deleteTeachers', context.getters.selected);
        },

        async deleteTeachers(context, teacherIds) {
            await TeachersService.deleteMultipleTeachers(context.getters.schoolId, teacherIds);
            context.dispatch('resetSelectedItems');
            if (teacherIds.length === context.getters.teachers.length) {
                context.dispatch('openPreviousPage');
            }
            clearAllSelected();
            await context.dispatch('getTeachers');
        },

        async toggleTeacherStatus(context, teacherId) {
            await TeachersService.toggleTeacherStatus(context.getters.schoolId, teacherId);
            await context.dispatch('getTeachers');
        },

        prepareTeacher(context, payload) {
            if (payload.type === 'edit') {
                context.commit(Mutations.SET_TEACHER_ID, payload.teacherId);
                context.dispatch('getTeacher');
                context.dispatch('openModal', {
                    modalName: 'TeacherModal',
                    callback: () => context.dispatch('unstageTeacher')
                });
            }
            else {
                context.dispatch('selectedIdItem', payload.teacherId);
                context.dispatch('openModal', {
                    modalName: 'TeacherMigrateChildren',
                    callback: () => context.dispatch('unstageTeacher')
                });
            }
        },

        unstageTeacher(context) {
            context.commit(Mutations.REMOVE_TEACHER_ID);
            context.commit(Mutations.REMOVE_TEACHER);
        }
    },
    getters: {
        teachers: state => state.teachers,

        teacherId: state => state.teacherId,

        teacher: state => state.teacher,

        allTeachers: state => state.allTeachers
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/teachers/teachers.module.js